export default __webpack_public_path__ + "static/datelabel-dropdown-do-3-light-057824ba0fda94b0b3b61f61eb7243d3.png";